import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Link } from 'react-router';

import themeable from 'zignal-landscape/lib/themeable';
import Grid from 'zignal-landscape/lib/Grid';
import Row from 'zignal-landscape/lib/Row';
import Col from 'zignal-landscape/lib/Col';

const composeErrorOrNotificationMessage = (styles, errorMessage, notificationMessage) => {
  if (errorMessage) {
    return (<div className={styles.errorMessage}>
      {errorMessage}
    </div>);
  }
  if (notificationMessage) {
    return (<div
      className={styles.notificationMessage}
      dangerouslySetInnerHTML={{ __html: notificationMessage }}
    />);
  }
  return '';
};

const LoginForm = ({
  styles,
  handleSubmit,
  errorMessage,
  notificationMessage,
  logoSrc,
  legacyLoginFormWithOkta,
  handleInputChange,
  handleForgotCredentials
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Grid fluid className={styles.background}>
        <div className={styles.loginFormBackround}>
          <Row className={styles.mainRow}>
            <Col sm={6} className={styles.logoCell}>
              <img className={styles.logo} src={logoSrc} />
            </Col>
            <Col className={styles.logoPaddingCell} smHidden mdHidden lgHidden xs={12} />
            <Col xs={9} sm={4}>
              <label className={errorMessage ? styles.errorUsernameLabel : styles.usernameLabel}>
                <Field
                  component="input"
                  className={styles.usernameInput}
                  name="username"
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  placeholder="Username"
                  onChange={handleInputChange}
                />
              </label>
              <label className={styles.passwordLabel}>
                <Field
                  component="input"
                  className={styles.passwordInput}
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={handleInputChange}
                />
              </label>
              {composeErrorOrNotificationMessage(styles, errorMessage, notificationMessage)}
            </Col>
            <Col xs={3} sm={2} className={styles.submitCell}>
              <button type="submit" className={styles.signInButton}>
                Sign In
              </button>
              { legacyLoginFormWithOkta === false &&
                <Link className={styles.forgotPassword} onClick={handleForgotCredentials}>
                  Forgot?
                </Link>
              }
            </Col>
            <Col className={styles.logoPaddingCell} smHidden mdHidden lgHidden xs={12} />
            <Col className={styles.invisibleCell} smHidden mdHidden lgHidden xs={12}>
              <img className={styles.logo} src={logoSrc} />
            </Col>
          </Row>
          <Row className={styles.termsTextRow}>
            <Col sm={6} smOffset={6}>
              <span>
                By clicking Sign In, you have read, understand, and agree to our
                <a href="http://zignallabs.com/zignal-terms-and-conditions"> Terms.</a>
              </span>
            </Col>
          </Row>
        </div>
      </Grid>
    </form>
  );
};

LoginForm.propTypes = {
  styles: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func,
  handleForgotCredentials: PropTypes.func,
  errorMessage: PropTypes.string,
  notificationMessage: PropTypes.string,
  children: PropTypes.node,
  logoSrc: PropTypes.string,
  legacyLoginFormWithOkta: PropTypes.bool
};

LoginForm.displayName = 'LoginForm';

export default themeable(LoginForm);
